import React, { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { fetchYardsApi } from '../../services/api';
import { servicoReporteIncidenciasTipoNivel } from '../../services/Reportes/ServicesReports';
import { Cargando } from '../../components/Cargando';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

export default function ReporteIncidenciasTipoNivel() {
  const { token } = useAuth();

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [yardId, setYardId] = useState('');
  const [yards, setYards] = useState([]);

  const [loadingYards, setLoadingYards] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const [rows, setRows] = useState([]);

  useEffect(() => {
    (async () => {
      setLoadingYards(true);
      setErrorMsg('');
      try {
        const list = await fetchYardsApi({ token });
        setYards((list || []).sort((a, b) => a.nombre.localeCompare(b.nombre)));
      } catch (err) {
        console.error(err);
        setErrorMsg('No se pudieron cargar los patios.');
      } finally {
        setLoadingYards(false);
      }
    })();
  }, [token]);

  const dataChart = useMemo(() => {
    return (rows || []).map((r) => ({
      name: r.type || 'Tipo',
      Bajo: Number(r.low || 0),
      Medio: Number(r.mid || 0),
      Alto: Number(r.high || 0),
      Total: Number(r.total || 0),
    }));
  }, [rows]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setRows([]);

    if (!yardId || !startDate || !endDate) {
      setErrorMsg('Seleccione patio y rango de fechas.');
      return;
    }

    setLoading(true);
    try {
      const res = await servicoReporteIncidenciasTipoNivel({ startDate, endDate, yardId, token });
      console.log(res);
      const arr = Array.isArray(res) ? res : (Array.isArray(res?.value) ? res.value : []);
      setRows(arr);
    } catch (err) {
      console.error(err);
      setErrorMsg('No se pudo obtener el reporte.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <h4 className="mb-3">Incidencias por Tipo y Nivel</h4>

      <div className="card">
        <div className="card-body">
          <form onSubmit={onSubmit}>
            <div className="row g-3 align-items-end">
              <div className="col-12 col-md-4">
                <label className="form-label">Patio</label>
                <select
                  className="form-select"
                  value={yardId}
                  onChange={(e) => setYardId(e.target.value)}
                  disabled={loadingYards}
                >
                  <option value="">-- Selecciona --</option>
                  {yards.map((y) => (
                    <option key={y.id} value={y.id}>{y.nombre}</option>
                  ))}
                </select>
                {loadingYards && <div className="form-text">Cargando patios...</div>}
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label">Fecha inicio</label>
                <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label">Fecha fin</label>
                <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              </div>

              <div className="col-12">
                <button className="btn btn-primary" type="submit" disabled={loading || loadingYards}>
                  {loading ? 'Consultando...' : 'Consultar'}
                </button>
              </div>
            </div>
          </form>

          {errorMsg && <div className="alert alert-danger mt-3">{errorMsg}</div>}

          <div className="mt-3">
            {loading && <Cargando />}

            {!loading && dataChart.length > 0 && (
              <div className="row g-3 justify-content-center">
                <div className="col-12 col-lg-12">
                  <div className="border rounded p-3" style={{ height: 500 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart data={dataChart} margin={{ top: 20, right: 20, bottom: 40, left: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" interval={0} angle={-20} textAnchor="end" height={100} />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Legend />
                        <Bar className='my-2' dataKey="Bajo" stackId="niv" fill="#4caf50" barSize={100} />
                        <Bar className='my-2' dataKey="Medio" stackId="niv" fill="#ffc107" barSize={100} />
                        <Bar className='my-2' dataKey="Alto" stackId="niv" fill="#dc3545" barSize={100} />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            )}

            {!loading && dataChart.length === 0 && !errorMsg && (
              <div className="text-muted">Sin resultados. Cambia los filtros y vuelve a consultar.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
